/**
 * NeuraDrive — Add-to-cart with drawer slide-in.
 * Intercepts forms with [data-nd-cart-form], AJAXes to /cart/add.js,
 * updates the cart count in the header, then opens Dawn's cart drawer.
 */
(function () {
  'use strict';

  var cart_item_count = parseInt(
    (document.querySelector('.nd-header__cart-count') || {}).textContent || '0', 10
  );

  function updateCartCount(count) {
    cart_item_count = count;
    var existing = document.querySelector('.nd-header__cart-count');
    if (count > 0) {
      if (existing) {
        existing.textContent = count;
      } else {
        var cartLink = document.querySelector('.nd-header__cart');
        if (cartLink) {
          var badge = document.createElement('span');
          badge.className = 'nd-header__cart-count';
          badge.textContent = count;
          cartLink.appendChild(badge);
        }
      }
    } else if (existing) {
      existing.remove();
    }
  }

  function openCartDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return false;
    drawer.classList.remove('is-empty');
    drawer.classList.add('active');
    setTimeout(function () { drawer.classList.add('animate'); }, 0);
    document.body.classList.add('overflow-hidden');
    return true;
  }

  async function refreshDrawerContents() {
    // Re-fetch the cart drawer HTML so it shows the new line items.
    try {
      var res = await fetch(window.location.pathname + '?sections=cart-drawer');
      if (!res.ok) return;
      var json = await res.json();
      var html = json['cart-drawer'];
      if (!html) return;
      var parsed = new DOMParser().parseFromString(html, 'text/html');
      var newDrawer = parsed.querySelector('cart-drawer');
      var currentDrawer = document.querySelector('cart-drawer');
      if (newDrawer && currentDrawer) {
        currentDrawer.innerHTML = newDrawer.innerHTML;
      }
    } catch (e) {
      // non-blocking — drawer will still open with stale data
      console.warn('[nd-cart] drawer refresh failed', e);
    }
  }

  /* Quantity input — snap back to 1 if user enters 0 or empty.
     Big-brand pattern (Apple, Allbirds, Cuyana): removal only via trash icon,
     never via typing 0. Also prevents a Dawn cart.js bug where the cart drawer
     quantity inputs use #Drawer-quantity-X but resetQuantityInput looks for
     #Quantity-X and throws "Cannot read properties of null". */
  function isQuantityInput(el) {
    if (!el || !el.matches) return false;
    return (
      el.matches('input.quantity__input') ||
      el.matches('input[name^="updates"]') ||
      el.matches('input[id^="Drawer-quantity-"]') ||
      el.matches('input[id^="Quantity-"]') ||
      el.matches('cart-drawer-items input[type="number"]') ||
      el.matches('cart-items input[type="number"]')
    );
  }
  function clampToMinOne(input) {
    var raw = (input.value || '').trim();
    var value = parseInt(raw, 10);
    if (isNaN(value) || value < 1) {
      input.value = '1';
      input.setAttribute('value', '1');
      return true;
    }
    return false;
  }

  // Capture-phase listeners run BEFORE Dawn's handlers — we intercept 0 first.
  document.addEventListener(
    'change',
    function (e) {
      if (!isQuantityInput(e.target)) return;
      if (clampToMinOne(e.target)) {
        e.stopImmediatePropagation();
        e.preventDefault();
      }
    },
    true
  );
  document.addEventListener(
    'input',
    function (e) {
      if (!isQuantityInput(e.target)) return;
      // Don't clamp during active typing (user might be deleting to retype),
      // but strip non-digits so they can't enter "0", "-1", "abc", etc.
      var cleaned = (e.target.value || '').replace(/[^0-9]/g, '');
      if (cleaned !== e.target.value) e.target.value = cleaned;
    },
    true
  );
  document.addEventListener(
    'blur',
    function (e) {
      if (!isQuantityInput(e.target)) return;
      clampToMinOne(e.target);
    },
    true
  );
  document.addEventListener(
    'keydown',
    function (e) {
      if (!isQuantityInput(e.target)) return;
      // Block "0" as the first character — must be 1+
      if (e.key === '0' && (e.target.value === '' || e.target.value === '0')) {
        e.preventDefault();
      }
    },
    true
  );

  /* Cart icon click → open drawer instead of navigating to /cart.
     Does NOT rely on Dawn's custom element being initialized —
     drives visibility purely via CSS classes that component-cart-drawer.css
     already responds to (.active → visibility:visible, translateX(0)). */
  function openDrawerDirect(drawer) {
    if (cart_item_count === 0) {
      drawer.classList.add('is-empty');
    } else {
      drawer.classList.remove('is-empty');
    }
    drawer.classList.add('active');
    setTimeout(function () { drawer.classList.add('animate'); }, 0);
    document.body.classList.add('overflow-hidden');

    var overlay = drawer.querySelector('#CartDrawer-Overlay');
    if (overlay && !overlay._ndBound) {
      overlay.addEventListener('click', function () { closeDrawerDirect(drawer); });
      overlay._ndBound = true;
    }
    var closeBtn = drawer.querySelector('.drawer__close');
    if (closeBtn && !closeBtn._ndBound) {
      closeBtn.addEventListener('click', function () { closeDrawerDirect(drawer); });
      closeBtn._ndBound = true;
    }
    document.addEventListener('keyup', function handler(evt) {
      if (evt.code === 'Escape') {
        closeDrawerDirect(drawer);
        document.removeEventListener('keyup', handler);
      }
    });
  }

  function closeDrawerDirect(drawer) {
    drawer.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
  }

  window.ndOpenCart = function () {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) {
      window.location.href = '/cart';
      return;
    }
    openDrawerDirect(drawer);
  };

  document.addEventListener('submit', async function (e) {
    var form = e.target;
    if (!form.matches('[data-nd-cart-form]')) return;
    e.preventDefault();

    var button = form.querySelector('button[type="submit"]');
    if (!button) return;
    if (button.disabled) return;

    var originalLabel = button.innerHTML;
    button.disabled = true;
    button.dataset.loading = 'true';
    button.innerHTML = '<span class="nd-cart-spinner" aria-hidden="true"></span> Adding…';

    try {
      var formData = new FormData(form);
      formData.append('sections', 'cart-drawer');
      formData.append('sections_url', window.location.pathname);

      var addRes = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      });

      if (!addRes.ok) {
        var err = await addRes.json().catch(function () { return null; });
        throw new Error((err && err.description) || 'Could not add to cart');
      }

      var cartRes = await fetch('/cart.js');
      var cart = await cartRes.json();
      updateCartCount(cart.item_count);

      await refreshDrawerContents();

      button.innerHTML = '✓ Added';

      var opened = openCartDrawer();
      if (!opened) {
        // No drawer present — fall back to checkout
        window.location.href = '/checkout';
        return;
      }

      setTimeout(function () {
        button.innerHTML = originalLabel;
        button.disabled = false;
        delete button.dataset.loading;
      }, 1500);
    } catch (err) {
      console.error('[nd-cart] add failed', err);
      button.innerHTML = originalLabel;
      button.disabled = false;
      delete button.dataset.loading;
      alert(err.message || 'Sorry, could not add to cart. Please try again.');
    }
  });
})();
